import baseUrl from "../config/baseUrl";

const saveRequestedDocument = async ({ token, tags }) => {
  try {
    const response = await fetch(`${baseUrl}/api/add-multiple-doc-request-data`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(tags),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default saveRequestedDocument;
